import styled, { css } from 'styled-components';

import { colors, radius } from '../../styles/tokens';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
  isChecked: boolean;
}

export const ContainerInput = styled.label<ContainerProps>`
  position: relative;
  display: inline-block;
  width: 52px;
  height: 30px;

  background-color: transparent;

  ${props =>
    props.isErrored &&
    css`
      border-color: ${colors.error};
    `}
`;

export const Input = styled.input`
  opacity: 0;
`;

export const Slider = styled.label<ContainerProps>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${colors.surfaceContainerHighest};
  border-radius: ${radius.full};

  transition: 0.3s;

  ${props =>
    props.isChecked &&
    css`
      background-color: ${colors.primary};
    `}

  ${props =>
    props.isFocused &&
    css`
      box-shadow: 0 0 0 2px ${colors.primary}40;
    `}

  &::before {
    position: absolute;
    content: '';
    height: 22px;
    width: 22px;
    left: 4px;
    bottom: 4px;
    background-color: #ffffff;
    border-radius: 50%;

    transition: 0.3s;

    ${props =>
      props.isChecked &&
      css`
        transform: translateX(22px);
      `}
  }
`;
